export default "__VITE_ASSET__D2W4L6IE__"